import React, { Component } from 'react';

import Table from "../../Table";
import { Panel } from "react-bootstrap";
import '../../../../assets/css/apiData.css';
import 'react-select/dist/react-select.css';
import Spinner from '../../../Spinner';
import { DASHBOARD_DEPOSITS_PER_MIDS } from '../../../../actions/types';
const store =  require('../../../../reducers/index');

class DashBoardDepositsPerMidComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deposits: undefined,
      loading: true,
      socket: false,

      columns: [{
        value: "merchantName",
        label: "Merchant",
        leftAligned: true,
        isNumber: false
      }, {
        value: "channelId",
        label: "PID",
        leftAligned: true,
        isNumber: true
      }, {
        value: "midName",
        label: "MID",
        leftAligned: true,
        isNumber: false
      }, {
        value: "attempts",
        label: "Attempts",
        rightAligned: true,
        isNumber: true
      }, {
        value: "pending",
        label: "Pending",
        rightAligned: true,
        isNumber: true
      }, {
        value: "rejected",
        label: "Rejected",
        rightAligned: true,
        isNumber: true
      }, {
        value: "failed",
        label: "Failed",
        rightAligned: true,
        isNumber: true
      },{
        value: "cancelled",
        label: "Cancelled",
        rightAligned: true,
        isNumber: true
      },{
        value: "reversed",
        label: "Reversed",
        rightAligned: true,
        isNumber: true
      },{
        value: "successful",
        label: "Successful",
        rightAligned: true,
        isNumber: true
      },{
        value: "successRate",
        label: "Success Rate",
        rightAligned: true,
        isNumber: true
      }]
    };
  }

  subscribeFunction = null;

  componentDidMount(){
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_DEPOSITS_PER_MIDS && this.props.thisMonth && state.depositsPerMids.socket) {
        this.setState({ deposits: state.depositsPerMids, loading: false, socket: state.depositsPerMids.socket });
        return;
      }

      if (state.update === DASHBOARD_DEPOSITS_PER_MIDS && !state.depositsPerMids.socket) {
        this.setState({ deposits: state.depositsPerMids, loading: false, socket: state.depositsPerMids.socket });
      }
    });
  };

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  tableData = () => {
    const { deposits } = this.state;

    if (!deposits) {
      return [];
    }

    return deposits.map(elem => {
      return {
        merchantName: elem.merchantName,
        channelId: elem.channelId,
        midName: elem.midName,
        attempts: elem.attempts,
        pending: elem.pending,
        failed: elem.failed,
        rejected: elem.rejected,
        successful: elem.successful,
        cancelled: elem.cancelled,
        reversed: elem.reversed,
        successRate: elem.successRate + "%"
      };
    });
  };

  render() {
    const { deposits, loading, columns } = this.state;

    let sellsWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> DEPOSITS PER MID </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && deposits) {
      sellsWrap = (
        <Panel style={ { height: '100%' } }>
          <Panel.Heading>
            <Panel.Title> DEPOSITS PERFORMANCE PER MID </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content payout-requests">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
                isStriped={ false }
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return sellsWrap;
  }

}

export default DashBoardDepositsPerMidComponent;